<p-listbox
  [options]="secondLevelReviews"
  [(ngModel)]="selectedSecondLevelReview"
  >
  <ng-template let-level pTemplate="item">
    <div class="do-next-listbox" data-test-id="queues-listbox">
      @if (level.isEnabled) {
        <div class="do-next-listbox-item" data-test-id="do-next-listbox-item">
          {{ level.description }}
        </div>
      }
      @if (!level.isEnabled) {
        <div
          class="do-next-listbox-item disabled"
          tooltipPosition="bottom"
          data-test-id="do-next-listbox-item"
          [pTooltip]="level.tooltip"
          [escape]="false"
          >
          {{ level.description }}
        </div>
      }
    </div>
  </ng-template>
</p-listbox>
<div class="flex justify-end mt-4">
  <button
    type="button"
    pButton
    label="Cancel"
    severity="info"
    class="mr-2"
    data-test-id="do-next-cancel-button"
    (click)="onCancel()"
  ></button>
  <button
    type="button"
    pButton
    label="Route"
    data-test-id="do-next-route-button"
    (click)="onDoNextRoute()"
    [loading]="routingPending"
    [disabled]="!selectedSecondLevelReview?.isEnabled"
  ></button>
</div>
